import { RedirectPaths, RedirectPathsEnum } from '@/common/constants';
import { SECURITY_CULTURE_VIEW_SURVEY } from '@/common/constants/external-urls';
import { AppButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import { SCLockIcon } from '@/utils/helpers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const StyledCardContainer = styled(FlexContainer)<{ isDemo?: boolean }>`
  position: relative;
  grid-area: sc;
  width: 100%;
  min-width: min-content;
  background-color: var(--purple-background);
  padding: var(--default-padding) var(--big-padding);
  border-radius: var(--medium-border-radius);
  margin: 0;
  overflow: hidden;
  position: relative;

  &.stretch-children {
    .children {
      overflow-y: hidden;
      overflow-x: auto;
      padding-bottom: var(--medium-padding);

      > div {
        flex: 1;

        > div {
          width: 100%;
        }
      }
    }
  }

  .absolute-icon {
    position: absolute;
    top: var(--medium-padding);
    right: var(--medium-padding);

    svg {
      height: 42px;
    }
  }
`;

export const RedParagraph = styled.p`
  color: var(--red-main);
  font-size: var(--small-font-size);
  line-height: var(--small-line-height);
  font-weight: 700;
  margin-top: var(--medium-padding);
  margin-bottom: 0;
`;
export const StyledH3 = styled.h3`
  font-size: var(--heading-small-font-size);
  line-height: var(--heading-small-line-height);
  font-weight: 700;
  margin: var(--xsmall-padding) 0;
`;

export const StyledP = styled.p`
  font-size: var(--small-font-size);
  line-height: var(--small-line-height-19);
  margin: 0;
  margin-bottom: var(--medium-padding);
  text-align: center;
`;

type SecurityCultureDemoScoreProps = {
  isSurveyPage?: boolean;
};

export const SecurityCultureDemoScore: React.FC<
  SecurityCultureDemoScoreProps
> = ({ isSurveyPage }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <StyledCardContainer
      id="sc-score-card"
      direction="column"
      justify="center"
      align={!isSurveyPage ? 'center' : 'flex-start'}
    >
      <div className={isSurveyPage ? 'absolute-icon' : undefined}>
        <SCLockIcon />
      </div>

      <RedParagraph>{t('security.culture.notMeasured')}</RedParagraph>
      <StyledH3>{t('security.culture')}</StyledH3>
      <StyledP
        dangerouslySetInnerHTML={{
          __html: t('security.culture.demo.dashboard.p'),
        }}
        className={isSurveyPage ? 'text-left' : 'text-center'}
      />

      <FlexContainer
        justify={isSurveyPage ? 'flex-start' : 'center'}
        className={isSurveyPage ? 'mt-3' : 'mt-0'}
        gap={12}
      >
        <AppButton
          label={t('security.culture.demo.book.dashboard')}
          icon="pi pi-calendar"
          onClick={() =>
            navigate(
              RedirectPaths[
                RedirectPathsEnum.SECURITY_CULTURE_SURVEY_PLANNER
              ](),
            )
          }
        />
        {isSurveyPage && (
          <a
            href={SECURITY_CULTURE_VIEW_SURVEY}
            target="_blank"
            rel="noopener noreferrer"
          >
            <AppButton
              label={t('security.culture.view-survey')}
              type="outlined"
              severity="no-background"
            />
          </a>
        )}
      </FlexContainer>
    </StyledCardContainer>
  );
};
